export const sanitizeDecimalInput = (raw: string, decimals: number) => {
  if (decimals <= 0) return raw.replace(/[^\d]/g, '');
  const cleaned = raw.replace(/[^\d.]/g, '');
  const dotIndex = cleaned.indexOf('.');
  if (dotIndex === -1) return cleaned;
  const intPart = cleaned.slice(0, dotIndex);
  const decPart = cleaned
    .slice(dotIndex + 1)
    .replace(/\./g, '')
    .slice(0, decimals);
  return `${intPart}.${decPart}`;
};
